var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-dialog',{attrs:{"title":"坐标预览","size":"medium","visible":_vm.showDialog,"close":_vm.closeDialog}},[_c('div',[(_vm.showDialog)?_c('unit-map',{ref:"refUnitMap"}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }